{
  "schemaVersion": "qec-trace-0.3",
  "engineVersion": "1.0.0",
  "pathMapVersion": "qec-path-map-0.3.0",
  "manifestationVersion": "qec-manifestation-0.2",
  "program": "אור",
  "programHash": "fnv1a32-ddb3d910",
  "seed": 21,
  "initialState": [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    21
  ],
  "events": [
    {
      "sequence": 0,
      "instructionIndex": 0,
      "letter": "א",
      "transform": "preserve-frame",
      "route": [
        "Keter",
        "Tiferet"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "KeterService",
        "TiferetScheduler"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        21
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        21
      ],
      "beforeHash": "156f9321",
      "afterHash": "156f9321",
      "coherence": {
        "activation": 0.706,
        "phase": 4.103,
        "coherence": 0.941
      }
    },
    {
      "sequence": 1,
      "instructionIndex": 1,
      "letter": "ו",
      "transform": "mirror-exchange",
      "route": [
        "Hod",
        "Yesod"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "HodInterface",
        "YesodBus"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        21
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        21
      ],
      "beforeHash": "156f9321",
      "afterHash": "55def2bb",
      "coherence": {
        "activation": 0.896,
        "phase": 2.904,
        "coherence": 0.789
      }
    },
    {
      "sequence": 2,
      "instructionIndex": 2,
      "letter": "ר",
      "transform": "seed-rotation",
      "route": [
        "Yesod",
        "Malchut"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "YesodBus",
        "MalchutOutput"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        21
      ],
      "after": [
        21,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21
      ],
      "beforeHash": "55def2bb",
      "afterHash": "4f6ada5b",
      "coherence": {
        "activation": 0.034,
        "phase": 1.935,
        "coherence": 0.807
      }
    }
  ],
  "completeTraceHash": "fnv1a32-532b4003",
  "observation": {
    "step": 3,
    "reason": "program-end",
    "stateHash": "5335a8ca",
    "traceHash": "fnv1a32-532b4003",
    "candidates": [
      {
        "id": "register-order",
        "label": "Register order",
        "stateHash": "6035bd41",
        "focusLetter": "ת",
        "confidence": 0.536,
        "rationale": "Reads the manifested registers in machine order."
      },
      {
        "id": "mirror-order",
        "label": "Mirror order",
        "stateHash": "d98a0900",
        "focusLetter": "א",
        "confidence": 0.974,
        "rationale": "Reads the same state through its paired-register reflection."
      },
      {
        "id": "phase-offset",
        "label": "Aleph Olam phase",
        "stateHash": "bd1b66a5",
        "focusLetter": "ל",
        "confidence": 0.519,
        "rationale": "Projects the state through the shared Aleph Olam orientation."
      }
    ],
    "selectedProjection": "mirror-order",
    "snapshot": [
      21,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21
    ]
  }
}
